module.exports = __webpack_public_path__ + "static/media/255px_logo_bug_bm.b3acae2f.png";